if (!customElements.get('cart-upsell-card')) {
  customElements.define(
    'cart-upsell-card',
    class CartUpsellCard extends HTMLElement {
      connectedCallback() {
        this.addBtn = this.querySelector('.cart-upsell-card__add-btn');
        this.addLabel = this.querySelector('.cart-upsell-card__btn-label');
        this.priceSpan = this.querySelector('.cart-upsell-card__btn-price');
        this.separator = this.querySelector('.cart-upsell-card__btn-separator');
        this.mainImg = this.querySelector('.cart-upsell-card__main-img');
        this.variantBtns = [...this.querySelectorAll('.cart-upsell-card__variant-btn')];

        this.variantBtns.forEach((btn) => {
          btn.addEventListener('click', () => this.selectVariant(btn));
        });

        if (this.addBtn && !this.addBtn.dataset.choose) {
          this.addBtn.addEventListener('click', () => this.onAdd());
        }

        const activeVariantBtn =
          this.variantBtns.find((btn) => btn.classList.contains('is-active')) || this.variantBtns[0];

        if (activeVariantBtn) {
          this.selectVariant(activeVariantBtn);
        } else {
          this.updateButtonState(
            this.addBtn?.dataset.variantAvailable !== 'false',
            this.priceSpan?.textContent?.trim() || ''
          );
        }
      }

      selectVariant(btn) {
        this.variantBtns.forEach((variantBtn) => {
          variantBtn.classList.remove('is-active');
          variantBtn.setAttribute('aria-pressed', 'false');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        this.dataset.selectedVariantId = btn.dataset.variantId;

        if (this.mainImg && btn.dataset.imageSrc) {
          this.mainImg.src = btn.dataset.imageSrc;
          if (btn.dataset.imageSrcset) {
            this.mainImg.srcset = btn.dataset.imageSrcset;
          }
          if (btn.dataset.imageAlt) {
            this.mainImg.alt = btn.dataset.imageAlt;
          }
        }

        this.updateButtonState(btn.dataset.available !== 'false', btn.dataset.formattedPrice || '');
      }

      updateButtonState(isAvailable, formattedPrice) {
        if (!this.addBtn || !this.addLabel || this.addBtn.dataset.choose) return;

        const addLabel = this.addBtn.dataset.addLabel || 'Add to cart';
        const soldOutLabel = this.addBtn.dataset.soldOutLabel || 'Sold out';
        const title = this.addBtn.dataset.title || '';

        this.addLabel.textContent = isAvailable ? addLabel : soldOutLabel;
        this.addBtn.dataset.variantAvailable = isAvailable ? 'true' : 'false';

        const ariaLabel = isAvailable ? (title ? `${addLabel}: ${title}` : addLabel) : soldOutLabel;
        this.addBtn.setAttribute('aria-label', ariaLabel);

        if (isAvailable) {
          this.addBtn.removeAttribute('aria-disabled');
        } else {
          this.addBtn.setAttribute('aria-disabled', 'true');
        }

        if (this.separator) {
          this.separator.hidden = !isAvailable || !formattedPrice;
        }

        if (this.priceSpan) {
          this.priceSpan.hidden = !isAvailable || !formattedPrice;
          this.priceSpan.textContent = isAvailable ? formattedPrice : '';
        }
      }

      onAdd() {
        const variantId = this.dataset.selectedVariantId;
        if (!variantId || this.addBtn?.getAttribute('aria-disabled') === 'true') return;

        this.addBtn.setAttribute('aria-disabled', 'true');
        this.addBtn.classList.add('loading');

        const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cartEl ? cartEl.getSectionsToRender().map((section) => section.id) : [];

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1,
            sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('[cart-upsell-card] Error adding to cart:', response.description || response.message);
              return;
            }

            if (cartEl) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-upsell-card',
                productVariantId: variantId,
                cartData: response,
              });
              cartEl.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((error) => console.error('[cart-upsell-card] Fetch error:', error))
          .finally(() => {
            this.addBtn.classList.remove('loading');
            if (this.addBtn.dataset.variantAvailable !== 'false') {
              this.addBtn.removeAttribute('aria-disabled');
            }
          });
      }
    }
  );
}